import { Info } from 'lucide-react';
import type * as PopperJS from '@popperjs/core';
import { Tooltip } from './tooltip.tsx';
import { useThemeContext } from '../../../utils/providers/theme-context';

type InfoTooltipProps = {
  content: string;
  placement?: PopperJS.Placement;
};

export const InfoTooltip = ({
  content,
  placement = 'bottom'
}: InfoTooltipProps) => {
  const { getColour } = useThemeContext();
  return (
    <Tooltip label={content} placement={placement}>
      <Info
        className="h-4 w-4 cursor-help transition-colors"
        style={{ color: getColour('inactiveText') }}
      />
    </Tooltip>
  );
};
